var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiagramBar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M33.495,52.157h-6.244c-2.206,0-4,1.794-4,4v9.938c0,2.206,1.794,4,4,4h6.244c2.206,0,4-1.794,4-4v-9.938 C37.495,53.951,35.7,52.157,33.495,52.157z M27.251,66.095v-9.938h6.244l0.002,9.938H27.251z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.012,40.569h-6.244c-2.206,0-4,1.794-4,4v21.526c0,2.206,1.794,4,4,4h6.244c2.206,0,4-1.794,4-4V44.569 C55.012,42.363,53.218,40.569,51.012,40.569z M44.768,66.095V44.569h6.244l0.003,21.526H44.768z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.749,25.905h-6.244c-2.206,0-4,1.794-4,4v36.189c0,2.206,1.794,4,4,4h6.244c2.206,0,4-1.794,4-4V29.905 C72.749,27.7,70.955,25.905,68.749,25.905z M62.505,66.095V29.905h6.244l0.003,36.189H62.505z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagramBar);
export default __webpack_public_path__ + "static/media/diagram-bar.cc3f6901c8b22926f31b272e7b694e03.svg";
export { ForwardRef as ReactComponent };